import * as types from '../types'

export default {
    state: {
       is_work:false,
       localip:null
    },
    mutations: {
        [types.CHECKWORK]: (state, data) => {
            console.log(data);
        },
        [types.LOCALIP]: (state, data) => {
            console.log(data);
            state.localip = data;
        },
       
    },
    getters: {
        
    },
    actions: {
    }
}